<!--
============================================
THIS IS THE VUE3 VERSION OF THIS COMPONENT.
For the Vue2 version, see:
../../../../js/components/EvoxMediaAssets/EvoxMediaRotationalBanner.vue
============================================
-->

<template>
  <div v-if="bannerdata">
    <div
      v-if="bannerdata.rotationalBannerType.toLowerCase() === 'enhancedvideo' && bannerdata.styleId"
      :class="[ismobile ? 'banner-video-wrapper-mobile' : 'banner-video-wrapper']"
      :style="setImagePosition(bannerdata)"
    >
      <evox-media-component
        :styleid="+bannerdata.styleId"
        :imgstyles="
          ismobile
            ? 'width: 100%;max-width: 350px;max-height: 100%;'
            : 'width: 100%;max-width: 700px;max-height: 100%;'
        "
        :evoxmediastyles="
          ismobile
            ? 'width: 100%;max-width: 350px;max-height: 100%;'
            : 'width: 100%;max-width: 700px;max-height: 100%;'
        "
        :loop="
          bannerdata.enhancedAssetType && bannerdata.enhancedAssetType.toLowerCase() === '360-spin'
            ? true
            : false
        "
        :animation-type="bannerdata.enhancedAssetType"
        :evoxmediaprops="bannerdata.color ? `&color=${bannerdata.color}` : ''"
      />
    </div>
    <template
      v-if="bannerdata.rotationalBannerType.toLowerCase() === 'specialoffer' && bannerdata.offer"
    >
      <special-offer :bannerdata="bannerdata" @send-Disclaimer-toParent="handleChildDisclaimer" />
    </template>
    <template
      v-else-if="
        bannerdata.rotationalBannerType.toLowerCase() === 'vehicleoffer' &&
        bannerdata.bannersPaymentHomenetVehicle
      "
    >
      <vehicle-offer :bannerdata="bannerdata" @send-Disclaimer-toParent="handleChildDisclaimer" />
    </template>
    <template
      v-else-if="
        bannerdata.rotationalBannerType.toLowerCase() === 'vehicleofinterest' &&
        bannerdata.bannersPaymentHomenetVehicle
      "
    >
      <vehicle-of-interest
        :bannerdata="bannerdata"
        :callForPriceDetails="callForPriceDetails"
        @send-Disclaimer-toParent="handleChildDisclaimer"
      />
    </template>
    <template
      v-else-if="
        bannerdata.rotationalBannerType.toLowerCase() === 'vehicleapr' &&
        bannerdata.bannersPaymentHomenetVehicle
      "
    >
      <vehicle-apr-offer
        :bannerdata="bannerdata"
        @send-Disclaimer-toParent="handleChildDisclaimer"
      />
    </template>
  </div>
</template>

<script>
import EvoxMediaComponent from "@/js/components/EvoxMediaAssets/EvoxMediaComponent.vue";
import VehicleOffer from "../BannerOffers/VehicleOffer/VehicleOffer.vue";
import SpecialOffer from "../BannerOffers/SpecialOffer/SpecialOffer.vue";
import VehicleOfInterest from "../BannerOffers/VehicleOfInterest/VehicleOfInterest.vue";
import VehicleAprOffer from "../BannerOffers/VehicleAprOffer/VehicleAprOffer.vue";

export default {
  components: {
    EvoxMediaComponent,
    SpecialOffer,
    VehicleOffer,
    VehicleOfInterest,
    VehicleAprOffer,
  },
  props: {
    bannerdata: {
      required: true,
      default: null,
      type: Object,
    },
    callForPriceDetails: {
      required: false,
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      ismobile: window.ismobile,
    };
  },
  methods: {
    setImagePosition(banner) {
      let bannerStyles = {};
      if (!banner) {
        return;
      }
      if (this.ismobile) {
        if (banner.mobilePosition && banner.mobilePosition.toLowerCase() === "bottom") {
          bannerStyles = {
            bottom: "0px",
          };
        } else {
          bannerStyles = {
            top: "0px",
          };
        }
        return bannerStyles;
      } else if (banner.position && banner.position.toLowerCase() === "left") {
        bannerStyles = {
          left: "20%",
          transform: "translate(-20%, -50%)",
        };
      } else if (banner.position && banner.position.toLowerCase() === "right") {
        bannerStyles = {
          right: "20%",
          transform: "translate(20%, -50%)",
        };
      } else if (banner.position && banner.position.toLowerCase() === "farleft") {
        bannerStyles = {
          left: "0%",
          transform: "translate(0%, -50%)",
        };
      } else if (banner.position && banner.position.toLowerCase() === "farright") {
        bannerStyles = {
          right: "0%",
          transform: "translate(0%, -50%)",
        };
      } else {
        bannerStyles = {
          right: "20%",
          transform: "translate(20%, -50%)",
        };
      }
      return bannerStyles;
    },
    handleChildDisclaimer(data) {
      this.$emit("show-Offer-Disclaimer", data);
    },
  },
};
</script>
<style>
.desktop-video-settings {
  max-height: 100%;
}
.img-vdp-link {
  display: grid;
  grid-template-rows: 80% 20%;
  max-height: 100%;
}
.img-vdp-link .set-relative-height img {
  max-height: 100%;
  height:100%;
  width: 100%;
  object-fit: contain;
}
.bigger_design .img-vdp-link {
  align-self: center;
}
.medium_design .img-vdp-link {
  align-self: end;
}
.small_design .img-vdp-link {
  align-self: end;
}
.small_design .vdv_wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
}
.small_design .set-relative-height {
  max-width: 80%;
}
.banner-video-wrapper {
  position: absolute;
  top: 50%;
}
.banner-video-wrapper-mobile {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.banners-safe-area {
  position: absolute;
  top: 7%;
  left: 7%;
  right: 7%;
  bottom: 13%;
  width: 84%;
  height: 80%;
  margin: auto;
  font-size: calc(1px + 0.9vw);
}
.set-relative-height {
  max-width: 100%;
  height: auto !important;
  margin: 0 auto;
}
/* disclaimer on banner */
.disclaimer-on-banner {
  font-size: 9px;
  color: #000;
}
.read-more-text {
  text-transform: uppercase;
  text-decoration: underline;
}
.banner-has-disclaimer {
  display: grid;
  grid-template-rows: 90% 10%;
  max-height: 100%;
}
.small_design .disclaimer-on-banner {
  margin-top: 4px;
}
/* disclaimer on banner */
.op-wrapper {
  display: flex;
  flex-wrap: nowrap;
}
.noBannerWithBgImage .no-img-bg-color {
  padding: 50px 0px 100px 0px;
  position: static;
}
.offer-vehicle-name {
  letter-spacing: -1px;
}
.specials-banner-content {
  color: #000;
}
.info-year-type {
  font-size: 1.4em;
  line-height: 2;
}
.info-model {
  font-size: 3em;
  line-height: 1;
}
.offer-price {
  line-height: 0.8;
  white-space: nowrap;
  letter-spacing: -1px;
}
.dollar-position,
.offer-price-decimals {
  font-size: 3em !important;
}
.offer-price-text {
  font-size: 8em;
  display: inline-block;
}
.vin-stock-wrapper {
  gap: 0px 15px;
}
.offer-text3-label {
  line-height: 1.2 !important;
}
.offer-price-label {
  line-height: 1 !important;
  align-self: flex-end;
}
</style>

<style>
.mm-bg-container {
  padding: 8px;
}
@media (max-width: 767px) {
  .noBannerWithBgImage .mobile_layout.ml-size.no-img-bg-color {
    padding: 12px 0px 48px 0px;
    position: static;
  }
  .noBannerWithBgImage .mobile_layout.mm-size.no-img-bg-color {
    padding: 6px 0px 48px 0px;
    position: static;
  }
  .mobile_layout.banners-safe-area {
    position: absolute;
    top: 0%;
    left: 0%;
    right: 0%;
    bottom: 0%;
    width: 90%;
    min-width: 315px;
    height: 90%;
    margin: 0 auto;
    font-size: 16px;
  }
  .mobile_layout .offer-details-block,
  .mobile_layout .video-settings {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .mobile_layout .info-year-type {
    font-size: 0.9em;
    line-height: 1.5;
  }
  .mobile_layout .info-model {
    font-size: 1.5em !important;
  }
  .mobile_layout .offer-price {
    line-height: 0.8;
    white-space: nowrap;
    padding: 3px 0px !important;
  }
  .mobile_layout .dollar-position,
  .mobile_layout .offer-price-decimals {
    font-size: 2em !important;
  }
  .mobile_layout .offer-price-text {
    font-size: 4.5em;
    display: inline-block;
  }
  .mobile_layout .term-wrapper {
    font-size: 0.8em;
  }
  .mobile_layout .set-relative-height {
    height: auto !important;
    margin: 0 auto;
    max-width: 75%;
  }
  .mobile_layout .vin-stock-wrapper {
    flex-wrap: wrap;
    font-size: 11px !important;
    gap: 0px 10px;
  }

  /* mobile medium layout */
  .banners-safe-area.mobile_layout.mm-size {
    width: 90%;
  }
  .mobile_layout.mm-size .info-year-type {
    font-size: 12px;
  }
  .mobile_layout.mm-size .info-model {
    font-size: 1.1em !important;
  }
  .mobile_layout.mm-size .term-wrapper {
    font-size: 10px;
  }
  .mobile_layout.mm-size .offer-vehicle-name {
    padding-bottom: 5px !important;
  }
  .mobile_layout.mm-size .offer-price {
    padding: 1px 0px !important;
  }
  .mobile_layout.mm-size .dollar-position,
  .mobile_layout.mm-size .offer-price-decimals {
    font-size: 1.3em !important;
  }
  .mobile_layout.mm-size .offer-price-text {
    font-size: 3em;
    display: inline-block;
  }
  .mobile_layout.mm-size .vehicle-details_vdp a {
    font-size: 10px !important;
    padding: 5px 20px !important;
  }
  .mobile_layout.mm-size .set-relative-height {
    max-width: 100%;
  }
  .mobile_layout.mm-size .vin-stock-wrapper {
    font-size: 10px !important;
  }
  .mobile_layout .specials-banner-content:not(.offer-has-logo) {
    margin-top: 12px;
  }
  .mobile_layout.mm-size .specials-banner-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .ml-size .disclaimer-on-banner {
    font-size: 7px;
  }
  .mm-size .disclaimer-on-banner {
    font-size: 6px;
  }
  .mm-size.banner-has-disclaimer {
    grid-template-rows: 85% 15%;
  }
}
</style>

<style>
.medium_design.banners-safe-area {
  top: 9%;
  left: 7%;
  right: 7%;
  bottom: 16%;
  width: 86%;
  height: 75%;
  margin: auto;
  font-size: 15px;
  min-height: 500px;
}
.medium_design .dollar-position,
.medium_design .offer-price-decimals {
  font-size: 3.5em !important;
}
.medium_design .offer-price-text {
  font-size: 8em;
}
</style>

<style>
.small_design.banners-safe-area {
  top: 0%;
  left: 7%;
  right: 7%;
  bottom: 15%;
  width: 86%;
  height: 85%;
  margin: auto;
  font-size: 16px;
}
.small_design .logo-wrapper {
  top: 10px;
}
.small_design .info-model {
  font-size: 2.5em;
}
.small_design .info-year-type {
  font-size: 1.2em;
}
.small_design .dollar-position,
.small_design .offer-price-decimals {
  font-size: 2.5em !important;
}
.small_design .offer-price-text {
  font-size: 6em;
}
.small_design .set-relative-height {
  text-align: left;
}
.small_design .set-relative-height img {
  max-height: 350px;
}
.small_design .vehicle-details_vdp {
  display: flex;
  align-items: end;
  justify-content: center;
  gap: 15px;
}
.small_design .vehicle-details_vdp .vin-stock-wrapper {
  margin-top: 0px !important;
  align-items: end;
  line-height: 1;
}
.small_design .op-wrapper {
  padding: 0px !important;
}
.small_design .offer-vehicle-name {
  padding-bottom: 10px !important;
}
.small_design .vdv-play {
  padding-top: 10px !important;
}
</style>

<style>
@media (min-width: 1900px) {
  .banners-safe-area.bigger_design {
    font-size: calc(1px + 0.8vw);
  }
  .offer-price {
    letter-spacing: -2px;
  }
}
@media (min-width: 1400px) and (max-width: 1899px) {
  .medium_design.banners-safe-area {
    font-size: calc(1px + 0.6vw);
  }
  .medium_design .info-year-type {
    font-size: 2em;
  }
  .medium_design .info-model {
    font-size: 3.5em;
  }
  .small_design.banners-safe-area {
    font-size: calc(1px + 0.8vw);
    min-height: 300px;
  }
  .small_design .set-relative-height img {
    max-height: 275px;
  }
  .small_design .img-vdp-link .vehicle-details_vdp {
    margin-top: 8px;
  }
  .small_design .img-vdp-link {
    align-self: center;
  }
}
@media (min-width: 1200px) and (max-width: 1399px) {
  .offer-vehicle-name {
    padding-bottom: 10px !important;
  }
  .vdv-play {
    padding-top: 10px !important;
  }
  .banners-safe-area.bigger_design {
    font-size: calc(1px + 0.5vw);
  }
  .bigger_design .info-year-type {
    font-size: 2.3em;
  }
  .bigger_design .info-model {
    font-size: 4.5em;
  }
  .bigger_design .dollar-position,
  .bigger_design .offer-price-decimals {
    font-size: 4.5em !important;
  }
  .bigger_design .offer-price-text {
    font-size: 10em;
  }
  .medium_design.banners-safe-area {
    font-size: calc(1px + 0.5vw);
    min-height: 400px;
  }
  .medium_design .info-year-type {
    font-size: 2.2em;
  }
  .medium_design .info-model {
    font-size: 3.5em;
  }
  .medium_design .img-vdp-link .vehicle-details_vdp {
    margin-top: 8px;
  }
  .small_design.banners-safe-area {
    font-size: calc(1px + 0.8vw);
    min-height: 300px;
  }
  .small_design .info-model {
    font-size: 2.3em;
  }
  .small_design .dollar-position,
  .small_design .offer-price-decimals {
    font-size: 2.3em !important;
  }
  .small_design .offer-price-text {
    font-size: 5em;
  }
  .small_design .set-relative-height img {
    max-height: 235px;
  }
  .small_design .vehicle-details_vdp .vin-stock-wrapper {
    font-size: 12px;
  }
  .small_design .img-vdp-link .vehicle-details_vdp {
    margin-top: 8px;
  }
  .small_design .make-it-yours {
    font-size: 12px;
  }
  .small_design .img-vdp-link {
    align-self: center;
  }
  .noBannerWithBgImage .small_design .info-year-type {
    font-size: 1em;
  }
}
@media (min-width: 768px) and (max-width: 1199px) {
  .banners-safe-area.bigger_design {
    top: 0%;
    left: 7%;
    right: 7%;
    bottom: 16%;
    width: 86%;
    height: 84%;
    margin: 0 auto;
    font-size: calc(1px + 0.8vw);
    min-height: 300px;
  }
  .bigger_design .vin-stock-wrapper {
    font-size: 12px;
  }
  .medium_design.banners-safe-area {
    top: 0%;
    left: 7%;
    right: 7%;
    bottom: 16%;
    width: 86%;
    height: 84%;
    margin: 0 auto;
    font-size: calc(1px + 0.6vw);
    min-height: 300px;
  }
  .medium_design .info-year-type {
    font-size: 2em;
  }
  .medium_design .vin-stock-wrapper {
    font-size: 12px;
  }
  .medium_design .set-relative-height img {
    max-height: 150px;
  }
  .medium_design .img-vdp-link {
    align-self: center;
  }
  .small_design.banners-safe-area {
    font-size: calc(1px + 0.8vw);
    min-height: 230px;
  }
  .small_design .info-year-type {
    font-size: 1.5em;
  }
  .small_design .info-model {
    font-size: 2.5em;
  }
  .small_design .set-relative-height img {
    max-height: 235px;
  }
  .small_design .vehicle-details_vdp .vin-stock-wrapper {
    font-size: 10px;
  }
  .small_design .offer-vehicle-name {
    padding: 5px 0px !important;
  }
  .small_design .make-it-yours {
    font-size: 10px;
  }
}
</style>

<style>
.search-six-pack-carousel .small_design .info-year-type {
  font-size: 1em;
}
.search-six-pack-carousel .small_design .info-model {
  font-size: 2em;
}
.search-six-pack-carousel .small_design .offer-price-text {
  font-size: 5em;
}
.search-six-pack-carousel .small_design .vin-stock-wrapper,
.search-six-pack-carousel .small_design .make-it-yours {
  font-size: 12px;
}
.search-six-pack-carousel .small_design .img-vdp-link {
  align-self: center;
}
.search-six-pack-carousel.noBannerWithBgImage .no-img-bg-color {
  padding: 50px 0px 50px 0px;
  position: static;
}
.search-six-pack-carousel .banners-safe-area.small_design {
  top: 0%;
  bottom: 0%;
  height: 100%;
}
/* voi */
.search-six-pack-carousel .small_design .your-price-text {
  font-size: 5em;
}
.search-six-pack-carousel .small_design .voi-note {
  font-size: 1.2em;
  margin-bottom: 0px !important;
}
/* voi */
@media (min-width: 1200px) and (max-width: 1899px) {
  .search-six-pack-carousel .small_design .vin-stock-wrapper,
  .search-six-pack-carousel .small_design .make-it-yours {
    font-size: 9px;
  }
}
@media (min-width: 1200px) and (max-width: 1399px) {
  .search-six-pack-carousel .banners-safe-area.small_design {
    top: 0%;
    bottom: 10%;
    height: 90%;
  }
}
</style>

<style>
.image-url-3tile-component .small_design .info-year-type {
  font-size: 1em;
}
.image-url-3tile-component .small_design .info-model {
  font-size: 2em;
}
.image-url-3tile-component .small_design .offer-price-text {
  font-size: 5em;
}
.image-url-3tile-component .small_design .vin-stock-wrapper,
.image-url-3tile-component .small_design .make-it-yours {
  font-size: 12px;
}
.image-url-3tile-component .small_design .img-vdp-link {
  align-self: center;
}
.image-url-3tile-component.noBannerWithBgImage .no-img-bg-color {
  padding: 50px 0px 50px 0px;
  position: static;
}
.image-url-3tile-component .banners-safe-area.small_design {
  top: 0%;
  bottom: 0%;
  height: 100%;
}
.display-search-on-banner .image-url-3tile-component .banners-safe-area.small_design {
  top: 0%;
  bottom: 15%;
  height: 85%;
}
.display-search-on-banner .image-url-3tile-component.noBannerWithBgImage .no-img-bg-color {
  padding: 50px 0px 100px 0px;
}
/* voi */
.image-url-3tile-component .banners-safe-area.small_design .your-price-text {
  font-size: 5em;
}
.image-url-3tile-component .banners-safe-area.small_design .voi-note {
  font-size: 1.2em;
  margin-bottom: 0px !important;
}
/* voi */
@media (min-width: 1200px) and (max-width: 1899px) {
  .image-url-3tile-component .small_design .info-year-type {
    line-height: 1.5;
  }
  .image-url-3tile-component .small_design .vin-stock-wrapper,
  .image-url-3tile-component .small_design .make-it-yours {
    font-size: 9px;
  }
}
</style>
